<template>
	<div id="preview" class="column col-lg-6 col-md-6 col-sm-12">
		<div class="panel">
			<div class="panel-header">
				<div class="panel-title"><b>Prévisualisation</b></div>
				<div class="panel-body">
					<div class="" style="padding: 44px 0px">
						<div style="text-align: left" id="code">
							<table
								cellpadding="0"
								cellspacing="0"
								border="0"
								style="
									background-color: #fff;
									border-width: 0px;
									border: 0px;
									margin: 0 0 0 0;
									padding: 12px;
									color: #1f2322;
									font-family: Arial, Helvetica, sans-serif;
									width: 100%;
									max-width: 450px;
								"
							>
								<tr>
									<td
										valign="middle"
										style="
											padding-top: 0;
											padding-bottom: 16px;
											padding-left: 0;
											padding-right: 0;
											vertical-align: middle;
										"
									>
										<span
											style="
												color: #1f2322 !important;
												margin-bottom: 0;
												font-size: 18px;
												font-weight: 700;
											"
											>{{ username }}</span
										>

										<br />

										<span
											style="
												color: #002ba7 !important;
												font-size: 14px;
												font-weight: 700;
											"
											v-if="usertitle"
											v-html="usertitle"
										></span>
									</td>

									<td
										valign="middle"
										style="padding-top: 0; padding-bottom: 16px; padding-left: 16px; padding-right: 0; border-top: 0; border-bottom: 0: border-left: 0;
											vertical-align: middle; text-align: right;"
									>
										<img
											alt=""
											src="https://images.prismic.io/mk-website/e5b52b32-c6e8-4897-809f-e316de6c1f83_Mediakod-logo-vertical-sans-bord-perdu-positif.png?auto=compress,format"
											width="84"
											height="34"
											style="vertical-align: middle"
										/>
									</td>
								</tr>

								<tr v-if="userphone || usermail">
									<td
										valign="top"
										colspan="2"
										style="
											padding-top: 16px;
											padding-bottom: 16px;
											padding-left: 0;
											padding-right: 0;
											font-size: 14px;
										"
									>
										<a
											:href="'tel:' + userphone"
											style="
												color: #1f2322 !important;
												text-decoration: none;
											"
											>{{ userphone }}</a
										>
										<br />

										<a
											:href="'mailto:' + usermail"
											style="
												color: #1f2322 !important;
												text-decoration: none;
											"
											>{{ usermail }}</a
										>
									</td>
								</tr>

								<tr>
									<td
										valign="top"
										colspan="2"
										style="
											padding-top: 0;
											padding-bottom: 16px;
											padding-left: 0;
											padding-right: 0;
											font-size: 14px;
										"
									>
										<p
											style="
												margin-bottom: 0;
												color: #1f2322 !important;
											"
										>
											22/3 Résidence Grande Barre<br />7522 Lamain
											(Tournai), BE
										</p>
									</td>
								</tr>

								<tr>
									<td
										valign="top"
										colspan="2"
										style="
											padding-top: 0;
											padding-bottom: 0;
											padding-left: 0;
											padding-right: 0;
											font-size: 14px;
										"
									>
										<p style="margin-bottom: 0">
											Appelez-nous :
											<a
												href="tel:003269672430"
												style="
													color: #1f2322 !important;
													text-decoration: none;
												"
												>+32 69 67 24 30</a
											>
											<span style="color: #003ff4 !important"
												>&nbsp;&nbsp;/&nbsp;&nbsp;</span
											>Visitez
											<a
												href="https://mediakod.com"
												style="
													color: #1f2322 !important;
													text-decoration: underline;
												"
												>mediakod.com</a
											>
										</p>
									</td>
								</tr>
							</table>
						</div>
					</div>
				</div>
				<div class="panel-footer">
					<form>
						<div class="form-group">
							<label class="form-label" for="input-code"
								>Code de la signature</label
							>
							<textarea
								class="form-input"
								id="input-code"
								v-html="code"
							></textarea>
						</div>
						<button
							type="button"
							class="btn btn-primary"
							v-on:click="saveCode"
							style="margin-right: 10px"
						>
							Copier le code
						</button>
						<a
							id="download_link"
							class="btn btn-primary"
							href="#"
							download="signature.txt"
							>Télécharger le code</a
						>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Preview",
	props: {
		arr: Array,
	},
	data: function () {
		return {
			username: "",
			usertitle: "",
			userphone: "",
			usermail: "",
			code: "",
			textFile: null,
		};
	},
	watch: {
		arr: function () {
			this.username = this.arr[0];
			this.usertitle = this.arr[1];
			this.userphone = this.arr[2];
			this.usermail = this.arr[3];
		},
	},
	updated: function () {
		this.setCode();
	},
	methods: {
		setCode: function () {
			this.code = document.getElementById("code").innerHTML;
			this.code = this.code.trim();
			var link = document.getElementById("download_link");
			link.href = this.downloadCode(this.code);
		},
		saveCode: function () {
			document.getElementById("input-code").select();
			document.execCommand("copy");
			alert("Vous pouvez coller votre code !");
			return false;
		},
		downloadCode: function (the_code) {
			var code_file = new Blob([the_code], { type: "text/plain" });
			if (this.textFile !== null) {
				window.URL.revokeObjectURL(this.textFile);
			}
			this.textFile = window.URL.createObjectURL(code_file);
			return this.textFile;
		},
	},
};
</script>
